<template>
  <div>
    <img src="@/assets/images/wasWatched.png" alt="" v-if="wasWatched" />
    <img src="@/assets/images/wasNotWatched.png" alt="" v-else />
  </div>
</template>

<script>
export default {
  name: `WasWatched`,
  computed: {
    wasWatched() {
      if (Array.isArray(this.$store.state.user.history)) {
        if (this.$store.state.user.history.indexOf(this.video) > -1) {
          return true;
        }
      }
      return false;
    },
  },
  props: {
    video: String,
  },
};
</script>

